import React, { useState } from 'react';
import strings from 'strings';
import { FPCard, FPCardContent } from 'UI/components/atoms/FPCard';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';
import { Endpoints } from 'UI/constants/endpoints';
import { OptionRenderers, Selectors } from 'UI/utils/renderers';

const { globalSearchPerson } = OptionRenderers;

export const SelectFromDirectory = ({ onSelect }) => {
  const [selectedContactOrHA, setSelectedContactOrHA] = useState(null);

  const handleContactSelect = (_name, value) => {
    setSelectedContactOrHA(value);
    onSelect && onSelect(value);
  };

  return (
    <FPCard>
      <FPCardContent variant="relaxed">
        <AutocompleteSelect
          displayKey="full_name"
          getOptionSelected={Selectors.byId}
          groupBy={option => option.typeTitle}
          onSelect={handleContactSelect}
          placeholder={strings.candidates.creation.selectExistingFromDirectory.placeholder}
          renderOption={globalSearchPerson('full_name')}
          selectedValue={selectedContactOrHA}
          typeahead
          typeaheadLimit={20}
          typeaheadParams={{ entityType: 'hiringAuthorityOrName' }}
          url={Endpoints.Search}
        />
      </FPCardContent>
    </FPCard>
  );
};
